import { t } from 'i18next'
import { z } from 'zod'

export const DurationUnitName = z.enum([
  'SECOND',
  'MINUTE',
  'HOUR',
  'DAY',
  'MONTH',
  'YEAR'
])
export type DurationUnitName = z.infer<typeof DurationUnitName>

export const DurationWithSingleUnit = z.object({
  unit: DurationUnitName,
  value: z
    .number()
    .int(t('general.form.numberInt'))
    .nonnegative(t('general.form.cantBeLessThanZero'))
    .nullable()
})
export type DurationWithSingleUnit = z.infer<typeof DurationWithSingleUnit>
